module.exports = __webpack_public_path__ + "static/media/twitterColor.4daada76.svg";